// Implements: F-UIX-010
/**
 * A date as text for a list row, in the platform locale ("13 oct. 2026", `types/locale.ts`) and
 * the reader's own zone.
 *
 * `Intl.DateTimeFormat.format` throws `RangeError` for anything `Date` cannot
 * parse, and the lists that use this are mounted on guarded routes: one
 * malformed field in one row would blank the whole document. The raw value is
 * returned instead, which is also the string a bug report needs to quote.
 * The machine-readable value stays in the caller's `<time dateTime>`.
 */

import { PLATFORM_LOCALE } from "../../types/locale";

const DAY = new Intl.DateTimeFormat(PLATFORM_LOCALE, { dateStyle: "medium" });

export function dayText(raw: string): string {
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? raw : DAY.format(parsed);
}
